/* eslint-disable no-param-reassign */
import Vue from 'vue';

import Vuex from 'vuex';
import constants from './constants';

import Auth from './views/auth/store';
import Company from './views/companies/company/store';
import Companies from './views/companies/store';
import Campaigns from './views/companies/company/campaigns/store';
import Home from './views/home/store';
import Profile from './views/profile/store';
import Payments from './views/payments/store';
import Groups from './views/groups/store';
import Subscriptions from './views/subscriptions/store';
import TermsPrivacy from './views/footerPages/store';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: constants.isDev,
  modules: {
    Auth,
    Company,
    Companies,
    Home,
    Campaigns,
    Profile,
    Payments,
    TermsPrivacy,
    Subscriptions,
    Groups,
  },
  state: {
    error: undefined,
    message: undefined,
  },
  mutations: {
    error(state, error) {
      if (error) {
        error = error.data ? error.data.message || error.data.error : error.error || error;
      }
      state.error = error;
    },
    message(state, message) {
      state.message = message;
    },
  },
});
